import {isOfferListQueryKey, offerListCanonicalKeyOrder} from "./offer_list_url_filters";
import {IOfferListQueryValue, IOfferListUrlInput, shouldOmitQueryValue, toValueList} from "./offer_list_url_values";

const canonicalKeyRank = new Map(offerListCanonicalKeyOrder.map((key, index) => [key, index]));

const compareCanonicalKeys = (left: string, right: string) => {
    const leftRank = canonicalKeyRank.get(left);
    const rightRank = canonicalKeyRank.get(right);

    if (leftRank != null && rightRank != null) {
        return leftRank - rightRank;
    }

    if (leftRank != null) {
        return -1;
    }

    if (rightRank != null) {
        return 1;
    }

    return left.localeCompare(right);
};

const sortValues = (values: string[]): string[] => {
    const numeric = values.every((value) => Number.isFinite(parseInt(value, 10)));

    if (numeric) {
        return [...values].sort((left, right) => parseInt(left, 10) - parseInt(right, 10));
    }

    return [...values].sort((left, right) => left.localeCompare(right));
};

const normalizeListingValue = (value: IOfferListQueryValue): string[] => {
    if (shouldOmitQueryValue(value)) {
        return [];
    }

    if (value === true || value === "true") {
        return ["true"];
    }

    return sortValues(toValueList(value));
};

/** `null` is a key sent without a value (`?gclid`), as the browser query parser reports it. */
const keepForeignValue = (value: IOfferListQueryValue): (string | null)[] => {
    if (value === undefined || value === false) {
        return [];
    }

    return (Array.isArray(value) ? value : [value]).map((item) => (item === null ? null : String(item)));
};

const serializeKeys = (query: IOfferListUrlInput, keys: string[], toValues: (value: IOfferListQueryValue) => (string | null)[]): string[] =>
    keys.flatMap((key) =>
        toValues(query[key]).map((value) => (value === null ? encodeURIComponent(key) : `${encodeURIComponent(key)}=${encodeURIComponent(value)}`))
    );

/**
 * One representation of a filter set, independent of the order the user clicked the filters.
 * Listing keys follow `offerListFilterGroups`, then non-filters, then location keys alphabetically; their list values are sorted
 * and empty ones dropped. Repeated keys (`floor_choices=1&floor_choices=2`) match the API.
 * Other parameters (utm_*, gclid, ...) follow in their own order with their values untouched.
 */
export const serializeCanonicalQuery = (query: IOfferListUrlInput): string => {
    const keys = Object.keys(query);
    const listingKeys = keys.filter(isOfferListQueryKey).sort(compareCanonicalKeys);
    const foreignKeys = keys.filter((key) => !isOfferListQueryKey(key));

    return [...serializeKeys(query, listingKeys, normalizeListingValue), ...serializeKeys(query, foreignKeys, keepForeignValue)].join("&");
};

/** The listing's own part of the canonical query; compare it with `normalizeListingSearch` to decide on a redirect. */
export const serializeListingQuery = (query: IOfferListUrlInput): string =>
    serializeKeys(query, Object.keys(query).filter(isOfferListQueryKey).sort(compareCanonicalKeys), normalizeListingValue).join("&");

const decodeSearchComponent = (value: string): string => {
    try {
        return decodeURIComponent(value.replace(/\+/g, " "));
    } catch {
        return value;
    }
};

/**
 * The listing keys of a raw query string, in their own order and re-encoded like `serializeCanonicalQuery`,
 * so they can be compared with `serializeListingQuery`. Other parameters never force a redirect.
 */
export const normalizeListingSearch = (search: string): string =>
    search
        .split("&")
        .filter((part) => part !== "")
        .map((part) => {
            const separatorIndex = part.indexOf("=");
            const key = decodeSearchComponent(separatorIndex === -1 ? part : part.slice(0, separatorIndex));
            const value = decodeSearchComponent(separatorIndex === -1 ? "" : part.slice(separatorIndex + 1));

            return {key, value};
        })
        .filter(({key}) => isOfferListQueryKey(key))
        .map(({key, value}) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
        .join("&");

export const appendCanonicalQueryString = (url: string, query: IOfferListUrlInput): string => {
    const search = serializeCanonicalQuery(query);

    if (!search) {
        return url;
    }

    return url.indexOf("?") === -1 ? `${url}?${search}` : `${url}&${search}`;
};
import {isOfferListQueryKey, offerListCanonicalKeyOrder} from "./offer_list_url_filters";
import {IOfferListQueryValue, IOfferListUrlInput, shouldOmitQueryValue, toValueList} from "./offer_list_url_values";

const canonicalKeyRank = new Map(offerListCanonicalKeyOrder.map((key, index) => [key, index]));

const compareCanonicalKeys = (left: string, right: string) => {
    const leftRank = canonicalKeyRank.get(left);
    const rightRank = canonicalKeyRank.get(right);

    if (leftRank != null && rightRank != null) {
        return leftRank - rightRank;
    }

    if (leftRank != null) {
        return -1;
    }

    if (rightRank != null) {
        return 1;
    }

    return left.localeCompare(right);
};

const sortValues = (values: string[]): string[] => {
    const numeric = values.every((value) => Number.isFinite(parseInt(value, 10)));

    if (numeric) {
        return [...values].sort((left, right) => parseInt(left, 10) - parseInt(right, 10));
    }

    return [...values].sort((left, right) => left.localeCompare(right));
};

const normalizeListingValue = (value: IOfferListQueryValue): string[] => {
    if (shouldOmitQueryValue(value)) {
        return [];
    }

    if (value === true || value === "true") {
        return ["true"];
    }

    return sortValues(toValueList(value));
};

/** `null` is a key sent without a value (`?gclid`), as the browser query parser reports it. */
const keepForeignValue = (value: IOfferListQueryValue): (string | null)[] => {
    if (value === undefined || value === false) {
        return [];
    }

    return (Array.isArray(value) ? value : [value]).map((item) => (item === null ? null : String(item)));
};

const serializeKeys = (query: IOfferListUrlInput, keys: string[], toValues: (value: IOfferListQueryValue) => (string | null)[]): string[] =>
    keys.flatMap((key) =>
        toValues(query[key]).map((value) => (value === null ? encodeURIComponent(key) : `${encodeURIComponent(key)}=${encodeURIComponent(value)}`))
    );

/**
 * One representation of a filter set, independent of the order the user clicked the filters.
 * Listing keys follow `offerListFilterGroups`, then non-filters, then location keys alphabetically; their list values are sorted
 * and empty ones dropped. Repeated keys (`floor_choices=1&floor_choices=2`) match the API.
 * Other parameters (utm_*, gclid, ...) follow in their own order with their values untouched.
 */
export const serializeCanonicalQuery = (query: IOfferListUrlInput): string => {
    const keys = Object.keys(query);
    const listingKeys = keys.filter(isOfferListQueryKey).sort(compareCanonicalKeys);
    const foreignKeys = keys.filter((key) => !isOfferListQueryKey(key));

    return [...serializeKeys(query, listingKeys, normalizeListingValue), ...serializeKeys(query, foreignKeys, keepForeignValue)].join("&");
};

/** The listing's own part of the canonical query; compare it with `normalizeListingSearch` to decide on a redirect. */
export const serializeListingQuery = (query: IOfferListUrlInput): string =>
    serializeKeys(query, Object.keys(query).filter(isOfferListQueryKey).sort(compareCanonicalKeys), normalizeListingValue).join("&");

const decodeSearchComponent = (value: string): string => {
    try {
        return decodeURIComponent(value.replace(/\+/g, " "));
    } catch {
        return value;
    }
};

/**
 * The listing keys of a raw query string, in their own order and re-encoded like `serializeCanonicalQuery`,
 * so they can be compared with `serializeListingQuery`. Other parameters never force a redirect.
 */
export const normalizeListingSearch = (search: string): string =>
    search
        .split("&")
        .filter((part) => part !== "")
        .map((part) => {
            const separatorIndex = part.indexOf("=");
            const key = decodeSearchComponent(separatorIndex === -1 ? part : part.slice(0, separatorIndex));
            const value = decodeSearchComponent(separatorIndex === -1 ? "" : part.slice(separatorIndex + 1));

            return {key, value};
        })
        .filter(({key}) => isOfferListQueryKey(key))
        .map(({key, value}) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
        .join("&");

export const appendCanonicalQueryString = (url: string, query: IOfferListUrlInput): string => {
    const search = serializeCanonicalQuery(query);

    if (!search) {
        return url;
    }

    return url.indexOf("?") === -1 ? `${url}?${search}` : `${url}&${search}`;
};
